import { Link } from "react-router-dom";

export default function ArticleCard({ article, lang = "tr", index = 0 }) {
  const t = article.translations?.[lang] || {};
  const slug = t.slug;
  const route = article.type === "guide" ? `/kapadokya-rehberi/${slug}`
              : article.type === "encyclopedia" ? `/kapadokya-ansiklopedisi/${slug}`
              : `/kapadokya-gunlugu/${slug}`;
  const cat = article.category;
  const catName = cat?.translations?.[lang]?.name;

  return (
    <Link
      to={route}
      data-testid={`article-card-${slug}`}
      className="cc-card group block cc-reveal"
      style={{ animationDelay: `${0.05 * index}s` }}
    >
      <div className="cc-card-img-wrap aspect-[4/5] bg-cc-border mb-5 overflow-hidden">
        {article.featured_image_url && (
          <img
            src={article.featured_image_url}
            alt={t.title || ""}
            loading="lazy"
            className="cc-card-img w-full h-full object-cover"
          />
        )}
      </div>
      {catName && (
        <div className="text-[10px] tracking-overline uppercase text-cc-sepia mb-2">{catName}</div>
      )}
      <h3 className="cc-card-title font-serif text-2xl md:text-[1.65rem] leading-snug text-cc-text mb-3">
        {t.title}
      </h3>
      {t.excerpt && (
        <p className="text-sm text-cc-muted leading-relaxed line-clamp-3">{t.excerpt}</p>
      )}
    </Link>
  );
}
